<template>

  <el-row id="wrap" style="margin-bottom: 0;">

    <bdialog :config='bconfig'></bdialog>

    <!-- pushtask descript of new version -->
    <el-dialog  class='gDia' :title="$t('app_helptip')" v-model="pushState" size=''>
      <div style="width:840px;">
        <p style="color:#48576A;font-size:18px;margin-top:-6px;">{{$t('app_newpsetnewver')}}</p>
       
        <p class="gTopMg" style="line-height:25px;">&nbsp;&nbsp;&nbsp;&nbsp;{{$t('app_newptdetail')}}</p>

        <p class="" style="line-height:25px;">&nbsp;&nbsp;&nbsp;&nbsp;{{$t('app_newptdetail1')}}</p>

        <img  class="gTopMg" style="width:100%;" :src='pic1' >
        <img  class="gTopMg" style="width:100%;" :src='pic2' >
        <img  class="gTopMg" style="width:100%;" :src='pic3' >
      </div>
    </el-dialog>

	<!--顶部布局-->
	<el-col :span="24" class="header">
      <el-col :span="12">
        <img v-if="imgLogo" :src="imgLogo" class="logo">
        <span class="logoTxt">
			{{$t('lin_global.logoTitle')}}
		</span>
      </el-col>
      <el-col :span="12" class="rightbar" style=''>
        <el-dropdown @command="handleCommand" trigger="click">
				<span class="el-dropdown-link" style="color:#fff;cursor: pointer;">
					<!-- <img src="../assets/user.png" class="head"> --> {{$t('lin_global.hello')}}, {{nickname}}
					<i class="el-icon-caret-bottom el-icon--right"></i>
				</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="m">{{$t('lin_global.wdzl')}}</el-dropdown-item>
            <!-- <el-dropdown-item>修改密码</el-dropdown-item> -->
            <el-dropdown-item command="o">{{$t('lin_global.tcxt')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>

	<!--主体布局-->
	<el-col :span="24" id="container">

    <aside id="aside" ><!-- $route.path -->

      <el-menu :default-active="currentNav" style='background:white;' class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect" unique-opened router>

        <!--<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">-->
        <!-- todo 警告参考:https://cn.vuejs.org/v2/guide/list.html#key -->
        <template v-for="(item,index) in menuList" v-if="!item.hidden">

          <!--<el-submenu :index="index+''" v-if="!item.leaf">-->
          <!--如果父级菜单下没有子菜单,则不显示; (换句话说:菜单必须有子级才显示) -->
          <el-submenu :index="index+''" v-if="!item.leaf && item.children && item.children.length>0">

            <template slot="title" >
              <i v-if="item.meta" :class="item.meta.iconCls" style="margin-right:10px"></i>{{item.name}}
            </template>

            <el-menu-item class='smn' style='background:white;' v-for="(child,index) in item.children" :key="index" :index="child.path" v-if="!child.hidden">
              &nbsp;&nbsp;{{child.name}}
            </el-menu-item>

          </el-submenu>

          <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
            <template >
              <i v-if="item.meta" :class="item.meta.iconCls" style='margin:0 5px 0 -4px;'></i>{{item.children[0].name}}
            </template>
          </el-menu-item>
        </template>

      </el-menu>

    </aside><!-- 


		
    --><section id="conter"> <!--右边栏内容主体-->
        <div>
          <el-col :span="24">
            <BreadCrumb></BreadCrumb>
          </el-col>
          <el-col :span="24" style='padding-bottom:24px;'>
            <router-view></router-view>
          </el-col>
        </div>
    </section>

	</el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import { baseurl,urlAssets } from '../api/url'
import BreadCrumb from '@/components/global/breadcrumb.vue'

import ptd1 from '@/assets/images/ptd/ptd1.png'
import ptd2 from '@/assets/images/ptd/ptd2.png'
import ptd3 from '@/assets/images/ptd/ptd3.png'

import bdialog from '@/components/bulletin/bdialog'
export default {
  components: {
    BreadCrumb,bdialog
  },
  data(){
    return{
      //imgLogo:`${urlAssets.prefix}tms-server-web/model/logo.png`,
      //imgLogo: this.$store.getters.homeLogo,
      token:'',
      bconfig: '',
      pushState: false,
      pic1: ptd1,
      pic2: ptd2,
      pic3: ptd3
      // menuList: this.$store.getters.routes,
    }
  },
  watch: {
    mmatch () {
      console.log("改变了")
    }
  },
  computed: {
    menuList () {
      return this.$store.getters.routes
    },
    nickname () {
      return this.$store.getters.nick
    },
  	currentNav:function(){
  		var path = this.$route.path;
        var menu = path;
        if (path.indexOf('terList') !== -1) {
          menu = '/terList'
        }
        if (path.indexOf('accMess') !== -1) {
          menu = '/accMess'
        }
         if (path.indexOf('romList') !== -1) {
          menu = '/romList'
        }
         if (path.indexOf('romReview') !== -1) {
          menu = '/romReview'
        }
         if (path.indexOf('terOta') !== -1) {
          menu = '/terOta'
        }
        if (path.indexOf('rail') !== -1) {
          menu = '/rail'
        }
      if (path.indexOf('certificate') !== -1) {
        menu = '/certificate'
      }
  		return menu
  	}/*,
    imgLogo:function(){
      if(localStorage.getItem('logo')!=='null'){
        var logo = localStorage.getItem('logo');
        return `${urlAssets.prefix}` + logo;

      }else{
        return `${urlAssets.prefix}tms-server-web/model/logo.png`;
      }
    }*/,
    imgLogo:function(){
      return this.$store.getters.homeLogo
    }
  },
  mounted:function(){

    var that = this
  	this.token = localStorage.getItem('user');
    this.getInfo();
    this.getVBInfo()

    

    // this.isShowNewPushTip()
  },
  methods: {
    getVBInfo () {
      this.loading = true
      var _this = this
      this.$checkVBInfo((res) => {
        this.loading = false
        if (res.status === 200) {
          if (res.data.length == 1) {
            var info = res.data[0]
            if (info.type == 0) {
              _this.bconfig = {
                type: 2,
                edit: false,
                vinfo: {
                  title: info.name,
                  content: info.info
                },
                binfo: '',
                callback: () => {
                }
              }
            } else {
              _this.bconfig = {
                type: 2,
                edit: false,
                vinfo: '',
                binfo: {
                  title: info.name,
                  content: info.info
                },
                callback: () => {
                }
              }
            }
            
          } else if (res.data.length == 2) {
            _this.bconfig = {
              type: 2,
              edit: false,
              vinfo: {
                title: res.data[0].name,
                content: res.data[0].info
              },
              binfo: {
                title: res.data[1].name,
                content: res.data[1].info
              },
              callback: () => {
              }
            }
          }
        } else {
          this.$message(res.message)
        }
      }, () => {
        this.loading = false
        this.$message.error(this.$t('app_rqsError'))
      })
    },
    isShowNewPushTip () {
      var tms_usr_npt_tip = localStorage.tms_usr_npt_tip
      if (tms_usr_npt_tip && JSON) {
        var usrs = JSON.parse(tms_usr_npt_tip)
        var is = false
        if (usrs) {
          is = usrs[localStorage.userId]?true : false
        }
        if (!is) {
          usrs[localStorage.userId] = '1'
          localStorage.tms_usr_npt_tip = JSON.stringify(usrs)
          this.pushState = true
        }
      } else {
        var usrs = {}
        usrs[localStorage.userId] = '1'
        localStorage.tms_usr_npt_tip = JSON.stringify(usrs)
        this.pushState = true
      }
    },
    handleOpen (key, keyPath) {

    },
    handleClose (key, keyPath) {
    },
    handleSelect (key, keyPath) {

    },
    handleCommand(command) {
	    if(command == 'o'){

        axios.post(`${baseurl}/user/logout.do`,{token: localStorage.getItem('user')}).then(res=>{
          if (res.data.status === 200) {
            var lc = localStorage
            lc.logo = ''
            lc.mechanismId = ''
            lc.user = ''
            lc.userId = ''
            lc.userType = ''
            lc.cerType=''
            this.$router.push({ path: '/login' })
            location.reload(true)
          } else {
            this.$message.error(res.data.message)
          }

        });
	    }else if(command == 'm'){
	    	this.$router.push({ path: '/accInfo' })
	    }
	},
	getInfo:function(){
		console.log('[keyPath-optional')
		let user = localStorage.getItem('user');/*{'token':"6d614e11-5000-40d6-aa1e-3c2ba2f7d24b"}*/

		var params = {token:user}
		axios.post(`${baseurl}/user/getUser.do`,params).then(res=>{
            //localStorage.setItem('userid',res.data.data.userid);
            //this.nickname = res.data.data.nickName;
            var params = {userId:res.data.data.userid};
            this.$setWObj('keyInfo', {key: res.data.data.appkey, secret: res.data.data.secretkey})
            //localStorage.setItem('userId',res.data.data.userid)
            //localStorage.setItem('mechanismId',res.data.data.mechanismId)
				axios.post(`${baseurl}/user/getUserById.do`,params).then(res=>{
		            // this.nickname = res.data.data.nickName;
                this.$store.dispatch('setNick', res.data.data.nickName)
		        })
        })
	}
  }
}
</script>

<style scoped>
	#wrap{
	  display: flex;
	  flex-flow: column;
	  height: 100%;
	  width: 100%;
	}
	.fz{
		font-size: 20px;
	}
  .breadcrumbTitle {
    /*color:red;*/
    font-size: 20px;
    /*font-weight: bold;*/
  }
	.header{
    height: 80px;
    
		line-height: 80px;
		background-color: rgb(32, 160, 255);
		color: #FFF;
    flex: 0 0 auto;
    border-radius: 0;
	}

  

	.header .rightbar {
		text-align: right;
		padding-right: 35px;
	}

	.header .rightbar .head {
		width: 40px;
		height: 40px;
		border-radius: 20px;
		margin: 18px 0px 10px 10px;
		float: right;
	}
	.logo {
		/*width: 135px;
		float: left;
		margin: 28px 10px 20px 20px;
		border-right:1px solid #fff;
		padding-right: 10px;*/
    float: left;
    padding-right: 20px;
    padding-left: 20px;
    height: 40px;
    margin-top: 20px;
	}
	.logoTxt{
		float:left;
  		font-size: 20px;
	}
	#container{
	    /* flex: 1;
	    display: flex;
      flex-flow: row; */
      

      flex: 1;
	    display: flex;
      flex-flow: row;
      height: 100%;
      position: relative;
      overflow: hidden;
      /* margin-top: 80px; */

      
	}
	#aside{
  		/* position: relative;
    	flex: 0 0 16.5%;
      overflow-y: auto;
      border-right:1px solid rgb(223,230,236) */

      position: relative;
    	flex: 0 0 16.5%;
      overflow: scroll;
      border-right:1px solid rgb(223,230,236)
	}
	#conter{
	    overflow-y: scroll;
	    flex: 1;
      padding:10px 24px 0 24px;

     
	}
	.fr{
		float: right;
	}

  /* el-menu-vertical-demo div:hover{background:red;}
  ul:hover{background:red;}
  li:hover{background:red;} */
  .smn:hover{background:red;color:#20A0FF;}


</style>




// WEBPACK FOOTER //
// home.vue?8e2c2e02